import React from 'react';

const EyeIcon = ({ isVisible }) => {
  return <i className={`fa ${isVisible ? 'fa-eye' : 'fa-eye-slash'}`}></i>;
};

const VisibilityButton = ({
  item,
  onToggleItemVisiblity,
  groupItem,
  onToggleGroupVisiblity,
  addMode,
  editMode
}) => {
  const linkStyle = { color: '#0C8ED7' };

  if (item && addMode && editMode) {
    if (item.isAdding || item.isEditing) {
      return (
        <a
          style={linkStyle}
          onClick={() =>
            onToggleItemVisiblity(item, item.isAdding ? addMode : editMode)
          }>
          <EyeIcon isVisible={item.isVisible} />
        </a>
      );
    } else {
      return (
        <a
          style={linkStyle}
          onClick={() => onToggleItemVisiblity(item, addMode, true)}>
          <EyeIcon isVisible={item.isVisible} />
        </a>
      );
    }
  } else if (groupItem) {
    return (
      <a
        style={linkStyle}
        onClick={() => onToggleGroupVisiblity(!groupItem.isVisible)}>
        <EyeIcon isVisible={groupItem.isVisible} />
      </a>
    );
  }
};

export default VisibilityButton;
